// extracted by mini-css-extract-plugin
export default {"googleLogo":"SignInGoogle_googleLogo__GfMka","googleLogin":"SignInGoogle_googleLogin__n97hK"};